module.exports = __webpack_public_path__ + "static/img/index1.8799c28.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/index1.png
// module id = vbMr
// module chunks = 7